module.exports = __webpack_public_path__ + "fonts/roboto-medium-webfont.07b0f0d.woff";